import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import { useParams, useHistory } from "react-router-dom";
import EmployeeOptionsStatement from "./EmployeeOptionsStatement";

const EmployeeOptionsPage = () => {
  const { employeeId } = useParams();
  const history = useHistory();

  const handleEmployeeChange = (newEmployeeId) => {
    const currentId = employeeId ? parseInt(employeeId, 10) : null;
    if (newEmployeeId !== currentId) {
      history.push(`/options/employees/${newEmployeeId}`);
    }
  };

  return (
    <Container fluid>
      <Row>
        <Col>
          <EmployeeOptionsStatement
            initialEmployeeId={employeeId ? parseInt(employeeId, 10) : null}
            onEmployeeChange={handleEmployeeChange}
          />
        </Col>
      </Row>
    </Container>
  );
};

export default EmployeeOptionsPage;
